/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formatters.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Formatter functions for Voice Guides module.
    Handles date formatting, voice name formatting, etc.
────────────────────────────────────────────────────────────────*/

/**
 * Format date value for display
 */
export function formatDate(value: unknown): string {
  if (!value) {
    return '-';
  }

  const source =
    value instanceof Date
      ? value
      : typeof value === 'string'
        ? new Date(value)
        : new Date(String(value));

  if (Number.isNaN(source.getTime())) {
    return '-';
  }

  const formatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return formatter.format(source);
}

/**
 * Format voice name (capitalize first letter)
 */
export function formatVoiceName(voiceName: string | null | undefined): string {
  if (!voiceName) {
    return '-';
  }

  return voiceName.charAt(0).toUpperCase() + voiceName.slice(1);
}

/**
 * Format language code (uppercase)
 */
export function formatLanguageCode(languageCode: string | null | undefined): string {
  if (!languageCode) {
    return '-';
  }

  return languageCode.toUpperCase();
}

/**
 * Format dialect code (uppercase)
 */
export function formatDialectCode(dialectCode: string | null | undefined): string {
  if (!dialectCode) {
    return '-';
  }

  return dialectCode.toUpperCase();
}

